import './App.css';
import Router from './shared/Router';
import GlobalStyle from './style/GlobalStyle';
function App() {
  return (
    <>
    <GlobalStyle />
    <Router />
    </>
  );
}

export default App;
